import { Button, Col, Drawer, Tooltip, Typography } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";

import Table from "../../../shared/components/ui/Table";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { rules2x1Service } from "../../../shared/services";
import { useNavigate } from "react-router-dom";
import { IRules2x1 } from "../../../redux/@types/rules2x1";
import { useUpdateStatusComboRules } from "../hooks/useUpdateStatusRules2x1";
import React from "react";
import { useRemoveComboRules } from "../hooks/useRemoveRules2x1";
import { EditComboRulesForm } from "./form";

const { Title, Text } = Typography;

export const TableRules2x1 = () => {
  const { showDeleteConfirm, setTableProps } = useRemoveComboRules();
  const { updateStatus, isLoading } = useUpdateStatusComboRules();
  const [openModalEditRule, setOpenModalEditRule] = React.useState<boolean>();
  const [ruleId, setRuleId] = React.useState<number>();
  const navigate = useNavigate();

  const handleNavigateEdit = (combo_id: number) => {
    navigate(`/combo-2-x-1-products/${combo_id}`);
  };
 
  const handleOpenEdit = (rule_id: number) => {
    setRuleId(rule_id)
    setOpenModalEditRule(true)
  };

  const columns: TableColumns<IRules2x1> = [
    {
      title: "Nombre",
      width: 7,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Estado",
      width: 7,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
              disabled={isLoading}
              onClick={() => {
                updateStatus(
                  item.status === "active" ? "inactive" : "active",
                  item.id
                );
              }}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Días",
      width: 10,
      key: "days",
      render: (_, item) => {
        const days: string[] = [];
        if (item.monday === "true") days.push("Lun");
        if (item.tuesday === "true") days.push("Mar");
        if (item.wednesday === "true") days.push("Mié");
        if (item.thursday === "true") days.push("Jue");
        if (item.friday === "true") days.push("Vie");
        if (item.saturday === "true") days.push("Sáb");
        if (item.sunday === "true") days.push("Dom");
        return <Text>{days.join(", ") || "Ninguno"}</Text>;
      },
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 10,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Tooltip title="Ver productos que se listan como 2x1">
              <Button
                type="primary"
                shape="circle"
                icon={<EyeOutlined />}
                size="large"
                onClick={() => handleNavigateEdit(item.id)}
              />
            </Tooltip>
            <Button
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              size="large"
              onClick={() => handleOpenEdit(item.id)}
            />
            <Button
              type="primary"
              danger
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
              onClick={() => showDeleteConfirm(item.id, item.name)}
            />
          </Col>
        );
      },
    },
  ];

  return (
    <>
      <Drawer
        title={`Editar una regla`}
        open={openModalEditRule}
        width={"320px"}
        destroyOnClose
        onClose={() => setOpenModalEditRule(false)}
      >
        <EditComboRulesForm setOpenModalEditRule={setOpenModalEditRule} ruleId={ruleId!}/>
      </Drawer>
      <Table<IRules2x1>
        columns={columns}
        fetchQueryProps={{
          $sort: { id: -1 },
        }}
        service={rules2x1Service}
        onLoad={setTableProps}
      />
    </>
  );
};
